import React from "react";
import { useParams } from "react-router-dom";
import ProjectsTable from "../components/projectCenter/projectScripts/PCProjects";
import PCProjectOpenWrapper from "../components/projectCenter/projectScripts/PCProjectOpenWrapper";
import TemplatesTable from "../components/projectCenter/templateScripts/PCTemplates";
import PCTemplateOpenWrapper from "../components/projectCenter/templateScripts/PCTemplateOpenWrapper";
const ProjectCenter = () => {
  const { sideTab, type, id } = useParams();

  return (
    <>
    {
      sideTab == "projects" && 
      (type == "table" || type == "timeline" ? 
      <ProjectsTable/> :  
      type == 'open' ? 
      <PCProjectOpenWrapper/> :
      id ? <PCProjectOpenWrapper/> :
      <ProjectsTable/>)
    }
    {sideTab == "templates" && 
      (type == "table" ? 
      <TemplatesTable/> : 
      type == 'open' ? 
      <PCTemplateOpenWrapper/> : 
      id ? <PCTemplateOpenWrapper/> : 
      <TemplatesTable/>)
    }
    </>
  );
};

export default ProjectCenter;
